import { useDispatch } from "react-redux";
import { AppDispatch } from "..";

export function useAppDispatch() {
    return useDispatch<AppDispatch>();
}
